import { EmptyView, emptyViewVariants } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const VatDeclarationsEmptyView = (): ReactElement => {
  const { t } = useTranslation()

  const { animation, description, title } = emptyViewVariants.vatDeclarations

  return (
    <ModuleLayout title={t('vat_declarations')}>
      <EmptyView animationName={animation} tDescription={description} tTitle={title} />
    </ModuleLayout>
  )
}
